require('!!raw-loader!/builds/740153/v2/src/index.html');